import React, {useEffect, useMemo, useState} from "react"
import FormSectionAccordion from "../../../../../components/FormSectionAccordion"
import theme from "../../../../../theme/theme"
import {ReactComponent as CheckIcon} from "../../../../../assets/icons/check-icon.svg"
import PropTypes from "prop-types"
import {renderGrid} from "../../../../../components/FieldRenderer"
import {mapPayloadRatingEmissao, mapRatingEmissao, ratingFields} from "./constants"
import {Box} from "@mui/material"
import ButtonWithIcon from "../../../../../components/Button/Button"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import EmissaoService from "../../../../../../services/emissao-service"
import DuplaConfirmacao from "../../../../../components/DuplaConfirmacao/DuplaConfirmacao"
import {dispatchSnackbar} from "../../../../../components/SnackBar/snackbar-bus"

const RatingSection = (
    {
        caracteristicasState,
        state,
        setRatingState,
        setSectionField,
        setLoading,
        isValid,
        showError,
        actions,
        defaultOpen = false,
        syncToken = 0,
        autoCompleteController = {}
    }) => {

    const ratingService = useMemo(() => new EmissaoService(), [])
    const [cetipRating, setCetipRating] = useState(null)
    const [cadastrarRatingOpen, setCadastrarRatingOpen] = useState(false)
    const [ratingRegistered, setRatingRegistered] = useState(false)

    useEffect(() => {
        if (caracteristicasState) {
            const {cetip, dataVencimento, devedor} = caracteristicasState
            if (cetip === cetipRating) return

            if (dataVencimento !== null) {
                setRatingState({...state, "Vencimento": dataVencimento, "CPFCNPJ": devedor})
            }

            setCetipRating(cetip)
            loadRatingEmissao(cetip, devedor)
        }
    }, [caracteristicasState])

    const loadRatingDevedor = (cpfCnpj) => {
        setLoading(true)
        ratingService.getUltimoRatingDevedor(cpfCnpj)
            .then((response) => {
                const {body: {data}} = response
                if (data !== null) {
                    const ratingEmissao = mapRatingEmissao(data)
                    setRatingState(ratingEmissao)
                    return
                }
                dispatchSnackbar("Rating devedor não cadastrado.", "warning")
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const loadRatingEmissao = (cetip, cpfCnpj) => {
        setLoading(true)
        ratingService.getUltimoRatingEmissao(cetip)
            .then((response) => {
                const {body: {data}} = response
                if (data !== null) {
                    const ratingEmissao = mapRatingEmissao(data)
                    setRatingState(ratingEmissao)
                    setRatingRegistered(true)
                    return
                }
                loadRatingDevedor(cpfCnpj)
                setSectionField("rating", {})
            })
            .catch((err) => {
                console.error("Não foi possível carregar os dados de rating emissao", err)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const createRatingEmissao = () => {
        const body = mapPayloadRatingEmissao(cetipRating, state)

        setLoading(true)
        ratingService.ratingEmissao('post', body)
            .then(() => {
                dispatchSnackbar("Rating cadastrado com sucesso!", "success")
            })
            .catch((error) => {
                const data = error?.response?.body || error?.response?.data || error?.response?.text
                dispatchSnackbar(`${JSON.stringify(data)}`, "error")
                console.log(error)
            })
            .finally(() => {
                setLoading(false)
                setCadastrarRatingOpen(false)
            })
    }

    const updateRatingEmissao = () => {
        setLoading(true)
        const {ID} = state
        const payload = mapPayloadRatingEmissao(cetipRating, state)
        ratingService.ratingEmissao('patch', ID, payload)
            .then(() => {
                dispatchSnackbar("Rating atualizado com sucesso!", "success")
            })
            .catch((err) => {
                dispatchSnackbar(`Erro ao atualizar rating. ${err}`, "error")
                console.log(err)
            })
            .finally(() => {
                setCadastrarRatingOpen(false)
                setLoading(false)
            })
    }

    return (
        <>
            <FormSectionAccordion
                title={"Rating Emissão"}
                icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}}/>}
                isValid={isValid}
                showError={showError}
                actions={actions}
                defaultOpen={defaultOpen}
                syncToken={syncToken}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "right",
                        mt: 3,
                        mb: 3,
                    }}
                >
                    <ButtonWithIcon size="md" icon={<AddCircleOutlineIcon/>}
                                    onClick={() => setCadastrarRatingOpen(true)}>
                        {ratingRegistered ? "ATUALIZAR RATING" : "CADASTRAR RATING"}
                    </ButtonWithIcon>
                </Box>
                {renderGrid(
                    ratingFields,
                    state,
                    (key) => (value) => setSectionField("rating", key, value),
                    undefined,
                    undefined,
                    (key) => (value) => setSectionField("rating", key, value),
                    autoCompleteController
                )}
            </FormSectionAccordion>

            <DuplaConfirmacao
                open={cadastrarRatingOpen}
                cancel={() => setCadastrarRatingOpen(false)}
                confirm={ratingRegistered ? updateRatingEmissao : createRatingEmissao}
                title={`${ratingRegistered ? "Atualizar" : "Cadastrar"} Rating`}
                description={`O rating da emissão ${cetipRating} será atualizado. Deseja continuar?`}
            />

        </>
    )
}

RatingSection.propTypes = {
    caracteristicasState: PropTypes.object,
    state: PropTypes.object.isRequired,
    setRatingState: PropTypes.func.isRequired,
    setSectionField: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    showError: PropTypes.bool,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
}

export default RatingSection